import React, { type FunctionComponent } from 'react'
import { type ApolloError } from 'apollo-client'
import {
  StoreGroupsForm,
  type StoreGroupsFormProps,
} from 'legacy/sections/store-groups/components/form/StoreGroupsForm'
import { StoreGroupsLoadError } from 'legacy/sections/store-groups/components/error/StoreGroupsLoadError'
import LoadingDots from 'legacy/components/LoadingDots'
import { type StoreGroup } from 'legacy/common/graphql-types/retailerLocationGroup.types'

export interface StoreGroupsEditBodyProps {
  storeGroup?: StoreGroup
  loading: boolean
  error?: ApolloError
  handleSubmit: StoreGroupsFormProps['handleSubmit']
}

export const StoreGroupsEditBody: FunctionComponent<StoreGroupsEditBodyProps> = ({
  handleSubmit,
  storeGroup,
  loading,
  error,
}) => {
  if (loading) {
    return <LoadingDots centered />
  }

  if (error || !storeGroup) {
    return <StoreGroupsLoadError />
  }

  return <StoreGroupsForm existingStoreGroup={storeGroup} handleSubmit={handleSubmit} />
}
